import { ENDPOINTS, getFullUrl } from "./config";

interface VideoTokenResponse {
  success: boolean;
  data?: {
    token: string;
  };
  message?: string;
}

export class VideoSdkService {
  static getToken(): string | null {
    return localStorage.getItem("token");
  }

  static async getVideoToken({
    uid,
    channelName,
  }: {
    uid: number;
    channelName: string;
  }): Promise<{ token: string } | null> {
    try {
      const url = new URL(getFullUrl(ENDPOINTS.VIDEOSDK.GETTOKEN));
      url.searchParams.append("uid", uid);
      url.searchParams.append("channelName", channelName);

      console.log("📡 API Request URL:", url.toString());

      const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
          "Cache-Control": "no-cache",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: VideoTokenResponse = await response.json();

      if (!data.success || !data.data?.token) {
        throw new Error(data.message || "Failed to get valid token");
      }

      return { token: data.data.token };
    } catch (error) {
      console.error("❌ Error in Generating token:", error);
      throw error;
    }
  }
}
